import { PositionStrategy, ScrollStrategy } from '@angular/cdk/overlay';

export type OverlayData = Record<string, unknown>;

export interface OverlayConfig {
  scrollStrategy?: ScrollStrategy;
  panelClass?: string | string[];
  position?: PositionStrategy;
  backdropClass?: string;
  hasBackdrop?: boolean;
  data?: OverlayData;
  reusable?: boolean;
  clickableBackdrop?: boolean
}

export enum ConnectedPosition {
  before = 'before',
  below = 'below',
  after = 'after',
  above = 'above',

  belowStart = 'below-start',
  belowEnd = 'below-end',

  aboveStart = 'above-start',
  aboveEnd = 'above-end',

  belowAlignRight = 'below-align-right',
  belowAlignLeft = 'below-align-left',

  aboveAlignRight = 'above-align-right',
  aboveAlignLeft = 'above-align-left',
}

export enum OverlayVerticalPosition {
  bottom = 'bottom',
  center = 'center',
  top = 'top',
}

export enum OverlayHorizontalPosition {
  end = 'end',
  center = 'center',
  start = 'start',
}

export interface OverlayPosition {
  horizontal?: OverlayHorizontalPosition;
  vertical?: OverlayVerticalPosition;
}
